<template>
    <div class="row">
        <!--Title-->
        <div class="text-right col-md-12">
            <el-tooltip content="Editar" placement="left">
                <p-switch v-model="editSettings" type="primary" >
                    <i class="fa fa-times" slot="on"></i>
                    <i class="fa fa-pencil" slot="off"></i>
                </p-switch>
            </el-tooltip>
            <h4 class="title center-title pull-left">Variables generales del sistema</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.systemSettings.loading"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Add Regional form-->
        <div v-if="!this.$apollo.queries.systemSettings.loading" class="mt-3 col-md-12 card">
            <form>
                <div class="card-header">
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Tiempo de inactividad del sistema</label>
                        <fg-input   ref="idle"
                                    type="number"
                                    name="tiempo"
                                    autocomplete="off"
                                    v-validate="modelValidations.idle"
                                    :error="getError('tiempo')"
                                    v-model="model.idle"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                </div>
                <div class="card-footer">
                    <div v-show="editSettings" class="text-right">
                        <p-button type="success" @click.prevent="validate">Aceptar</p-button>
                    </div>
                </div>
            </form>
        </div>
        <!--./Add Regional form-->
    </div>
    
    </template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { systemSettings } from 'src/api/graphql/queries/setup/AllSettings';
    import { EDIT_SETTINGS } from 'src/api/graphql/mutations/setup/EditSettings';
    import { orderBy , sortBy , find } from 'lodash';
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        systemSettings: {
                    query: systemSettings,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.systemSettings.length == 0)
                        {
                            this.systemSettings_array = [];
                        }
                        else
                        {
                            this.setSystemSettings(data.systemSettings);
                            this.$apollo.queries.systemSettings.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
        },
        components: {
        PSwitch,
        Loading,
        [Tooltip.name]: Tooltip
        },
        watch: {
            /*** 
            * Función que tiene vigilada la variable editSettings y poder activar el autofoco
            */    
            editSettings: function(val){
                if(val){
                    var vm = this;
                    vm.$refs.idle.$el.children[0].focus();//Asignamos focus en el campo
                }
            }
        },
        computed: {
        },
        data () {
        return {
            editSettings: false,
            isSending: false,
            fullPage: false,
            systemSettings_array : [],
            rowEdit: {},
            
            model: {
                idle: 0,
            },
            modelValidations: {
                idle: {
                    numeric: true,
                    required: true,
                    max: 8
                },
            },
        }
        },
        methods: {
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setSystemSettings(systemSettings){
                var vm = this;
                vm.model.idle = systemSettings.idleTime;
            },
            /*** 
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
                if(isLoading == true || isSending == true){
                    return true
                }
                else{
                    return false
                }
            },
            /**
            * Función que pone el foco en el campo de code
            */
            focusFirstField(){
            this.$refs.idle.$el.children[0].focus();//Asignamos focus en el campo
            },
            /*** 
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    vm.isSending = true;
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: EDIT_SETTINGS,
                        variables : {
                            input : {
                                idleTime: vm.model.idle
                            }
                        }
                    }).then((data) => {
                        vm.model.idle = data.data.systemSettings.systemSettings.idleTime;
                        vm.isSending = false;
                        vm.editSettings = false;
                        // vm.onSuccess('Variables editadas con éxito. No olvides modificar el archivo de configuración con la versión: '+data.data.systemSettings.systemSettings.versionId);
                        vm.onSuccess('Variables editadas con éxito');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                })
        }
        },
        mounted() {
        }
    }
    </script>
    <style lang="scss">
</style>
